import * as AWS from 'aws-sdk'

import { ConfigurationOptions } from 'aws-sdk'

const configuration: ConfigurationOptions = {
  region: process.env.REACT_APP_REGION,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY
}

AWS.config.update(configuration)

const docClient = new AWS.DynamoDB.DocumentClient()

import HttpClient from "./http-client";

export const fetchShiftUsers = async (tableName) => {
    var params = {
        TableName: tableName
    }

    var objectPromise = await docClient.scan(params).promise().then((data) => {
        return data.Items 
    })
    .catch(console.error)

    return objectPromise;
}

export const createLogItem = async (tableName, itemObject) => {
    var objectPromise = await docClient
    .put({
        Item: itemObject,
        TableName: tableName,
    })
    .promise()
    .then((data: any) => {
        return data;
    })
    .catch(console.error);

    return objectPromise;
}

export const fetchAllLogs = async (tableName) => {
    var params = {
        TableName: tableName
    }

    var objectPromise = await docClient.scan(params).promise().then((data) => {
        return data.Items 
    })
    .catch(console.error)

    return objectPromise;
}

export const queryTableItems = async (tableName, partitionValue) => {
    let params: any = {}
    if (tableName === "Shift-Engineers") {
        params = {
            TableName: tableName,
            KeyConditionExpression: '#Email = :Email',
            ExpressionAttributeNames: {
              '#Email': 'Email',
            },
            ExpressionAttributeValues: {
              ':Email': partitionValue,
            },
        };
    }
    else if (tableName === "SK-ShiftRoster") {
        params = {
            TableName: tableName,
            KeyConditionExpression: '#DATE = :DATE',
            ExpressionAttributeNames: {
              '#DATE': 'DATE',
            },
            ExpressionAttributeValues: {
              ':DATE': partitionValue,
            },
        };
    }
    else {
        console.log('VVV: ', partitionValue)
        params = {
            TableName: tableName,
            KeyConditionExpression: 'PK = :pk',
            ExpressionAttributeValues: {
              ':pk': 'LOG#' + partitionValue,
            },
        };
    }

    var objectPromise = await docClient.query(params).promise().then((data) => {
        return data.Items 
    })
    .catch(console.error)

    return objectPromise;
}

export const handoverDataToSSMIncidentManager = async (payload: any) => {
    try {
        const { data } = await HttpClient.post(`https://zsqpbbdk6tosuebyxwsj4gp4am0rlkvl.lambda-url.ap-south-1.on.aws`, payload);
        return data;
    } catch (error) {
        console.error(error);
        //return error
    }
}